// extracted by mini-css-extract-plugin
export default {"root":"PlasmicHeroUnerline_root__nCVFR"};